import { KeyValueModel } from "model/api";
import { EnumTipoFaturamentoSistema, EnumTipoFaturamentoSistemaLabel } from "model/enums/enum-tipo-faturamento-sistema";

export const TipoFaturamentoSistemaMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoFaturamentoSistema.Padrao, EnumTipoFaturamentoSistemaLabel[EnumTipoFaturamentoSistema.Padrao]),
    new KeyValueModel(EnumTipoFaturamentoSistema.Regra15Dias, EnumTipoFaturamentoSistemaLabel[EnumTipoFaturamentoSistema.Regra15Dias]),
    new KeyValueModel(EnumTipoFaturamentoSistema.RegraProximoMes, EnumTipoFaturamentoSistemaLabel[EnumTipoFaturamentoSistema.RegraProximoMes]),
];
